import React, { useEffect, useState } from 'react'
import { Info, MessageCircle, RotateCcw, Save, Settings, X } from 'lucide-react'
import { AgendaInteligenteController } from '../../../services/controllers/agendaInteligente'
import { useAgendaInteligente } from '../../../store/agendaInteligente/useAgendaInteligente'
import { useMerchant } from '../../../store/global/useMerchant'
import {
  AGENDA_TEMPLATE_VARIABLES,
  DEFAULT_AGENDA_TEMPLATE,
} from '../../../services/templates/agendaInteligente'
import { Action } from '../../../components/ui/Action'

export function SettingsModal() {
  const CAgendaInteligente = AgendaInteligenteController()
  const isOpen = useAgendaInteligente(st => st.data.settingsOpen)
  const current = useAgendaInteligente(st => st.data.template)
  const templateStoreId = useAgendaInteligente(st => st.data.templateStoreId)
  const storeId = useMerchant(st => st.data.merchant?.id)
  const [msg, setMsg] = useState(current)

  useEffect(() => {
    if (isOpen) setMsg(current)
  }, [current, isOpen])

  if (!isOpen || !storeId || templateStoreId !== storeId) return null

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4" onClick={CAgendaInteligente.closeSettings} role="presentation">
      <div
        aria-modal="true"
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-labelledby="agenda-settings-title"
        className="bg-white rounded-lg shadow-2xl w-full max-w-3xl flex flex-col overflow-hidden"
        style={{ maxHeight: '92vh' }}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-zinc-200">
          <div className="flex items-center gap-2">
            <Settings size={18} className="text-scale-500" />
            <span id="agenda-settings-title" className="font-semibold text-gray-800">Configurar mensagem padrão de WhatsApp</span>
          </div>
          <button onClick={CAgendaInteligente.closeSettings} className="text-gray-400 hover:text-gray-600 bg-transparent border-none cursor-pointer p-1" aria-label="Fechar configurações">
            <X size={18} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-5 flex flex-col gap-5">
          <div className="flex flex-col gap-3 p-4 bg-white rounded border border-zinc-200/40 shadow">
            <h2 className="flex items-center gap-2 text-scale-500 font-semibold text-sm">
              <Info size={15} className="text-scale-500" />
              Variáveis disponíveis na mensagem
            </h2>
            <div className="flex flex-wrap gap-2">
              {AGENDA_TEMPLATE_VARIABLES.map(v => (
                <button
                  key={v.var}
                  type="button"
                  className="flex max-w-full items-start gap-2 bg-gray-50 border border-zinc-200 rounded px-2.5 py-1.5 cursor-pointer hover:border-scale-200 hover:bg-scale-50 text-left"
                  onClick={() => setMsg(currentMessage => currentMessage + v.var)}
                  title="Clique para inserir"
                >
                  <code className="shrink-0 text-xs font-mono font-bold text-scale-600">
                    {v.var}
                  </code>
                  <span className="text-xs text-gray-500 break-words">- {v.desc}</span>
                </button>
              ))}
            </div>
            <div className="flex items-start gap-2 mt-1 p-3 bg-scale-50 border border-scale-200 rounded text-xs text-scale-700">
              <span className="shrink-0 mt-0.5">🐾</span>
              <span>
                Clique em uma variável para inserir no final da mensagem. O sistema substitui os dados automaticamente na hora do envio.
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-3 p-4 bg-white rounded border border-zinc-200/40 shadow">
            <h2 className="flex items-center gap-2 text-scale-500 font-semibold text-sm">
              <MessageCircle size={15} />
              Mensagem padrão
            </h2>
            <textarea
              value={msg}
              onChange={e => setMsg(e.target.value)}
              aria-label="Mensagem padrão de WhatsApp"
              rows={8}
              placeholder="Digite a mensagem padrão de WhatsApp..."
              className="w-full text-sm border border-zinc-200 rounded px-3 py-2 resize-y min-h-[180px] focus:outline-none focus:ring-2 focus:ring-scale-300 font-sans text-gray-700"
            />
          </div>
        </div>

        <div className="flex gap-3 px-6 py-4 border-t border-zinc-200 bg-gray-50 w-full">
          <div className='mr-auto'>
            <Action.Root
              outline
              type="button"
              className="mr-auto"
              onClick={() => setMsg(DEFAULT_AGENDA_TEMPLATE)}
            >
              <Action.Icon icon={RotateCcw} size={16} />
              Restaurar padrão
            </Action.Root>
          </div>

          <Action.Root
            outline
            type="button"
            onClick={CAgendaInteligente.closeSettings}
          >
            Fechar
          </Action.Root>

          <Action.Root
            type="button"
            onClick={() => CAgendaInteligente.saveTemplate(msg, templateStoreId)}
          >
            <Action.Icon icon={Save} size={16} />
            Salvar Configurações
          </Action.Root>
        </div>
      </div>
    </div>
  )
}
